import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { gql } from '@apollo/client';
import { Query } from '@apollo/react-components';
import { isAdmin } from '@achievable-me/tundra-wizard/auth';
import SpinnerError from '$components/library/SpinnerError';
import SubscribeButton from './SubscribeButton';
import AdminTabs from '$components/Admin/Tabs';
import { STAFF_USER_DETAILS } from './queries';
import styles from './styles.scss';

const PRODUCTS = gql`
  query Products {
    products {
      products {
        uuid
        name
        slug
      }
    }
  }
`;

const dateFormat = (value) => (value ? moment(value).format() : null);

const Field = (props) => {
  const { label, value } = props;
  return (
    <div className={styles.detailItem}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value || '(none)'}</div>
    </div>
  );
};

const UserDetails = (props) => {
  const { currentUser, user } = props;

  return (
    <Query query={STAFF_USER_DETAILS} variables={{ input: { uuid: user.uuid } }}>
      {({ loading, error, data }) => {
        if (loading || error) {
          return <SpinnerError error={error} />;
        }

        const {
          staffUserDetails: { user: userData },
        } = data;
        const {
          uuid,
          activeProductSlug,
          email,
          isoCountry,
          isoRegion,
          lat,
          lng,
          nickname,
          passwordModifiedAt,
          passwordResetExpiresAt,
          passwordResetToken,
          promo,
          referralCode,
          remoteAddr,
          source,
          stripeCustomerId,
          termsAt,
          userAgent,
          organization,
          subscriptions,
        } = userData;

        return (
          <div>
            <h4>Details</h4>
            <div className={styles.details}>
              <Field label="uuid" value={uuid} />
              <Field label="activeProductSlug" value={activeProductSlug} />
              <Field label="email" value={email} />
              <Field label="isoCountry" value={isoCountry} />
              <Field label="isoRegion" value={isoRegion} />
              <Field label="lat" value={lat} />
              <Field label="lng" value={lng} />
              <Field label="nickname" value={nickname} />
              <Field label="passwordModifiedAt" value={dateFormat(passwordModifiedAt)} />
              <Field
                label="passwordResetExpiresAt"
                value={dateFormat(passwordResetExpiresAt)}
              />
              <Field label="passwordResetToken" value={passwordResetToken} />
              <Field label="promo" value={promo} />
              <Field label="referralCode" value={referralCode} />
              <Field label="remoteAddr" value={remoteAddr} />
              <Field label="source" value={source} />
              <Field label="stripeCustomerId" value={stripeCustomerId} />
              <Field label="termsAt" value={dateFormat(termsAt)} />
              <Field label="userAgent" value={userAgent} />
            </div>

            <h4>Organization</h4>
            <div className={styles.details}>
              <Field label="uuid" value={_.get(organization, 'uuid')} />
              <Field label="name" value={_.get(organization, 'name')} />
            </div>

            <h4>Subscriptions</h4>
            <div className={styles.details}>
              <ul>
                {subscriptions.map((subscription) => {
                  return <li key={subscription.uuid}>{subscription.product.name}</li>;
                })}
              </ul>
              <AdminTabs subscriptions={subscriptions} />
            </div>
            {isAdmin(currentUser) && (
              <Query query={PRODUCTS}>
                {({
                  loading: productsLoading,
                  error: productsError,
                  data: productsData,
                }) => {
                  if (productsLoading || productsError) {
                    return <SpinnerError error={productsError} />;
                  }

                  const {
                    products: { products },
                  } = productsData;
                  const availableProducts = _.differenceWith(
                    products,
                    subscriptions,
                    (product, subscription) => product.uuid === subscription.product.uuid
                  );

                  return (
                    <SubscribeButton
                      key={availableProducts.length}
                      products={availableProducts}
                      user={user}
                    />
                  );
                }}
              </Query>
            )}
          </div>
        );
      }}
    </Query>
  );
};

export default UserDetails;
